(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('kiosks-dashboard', {
            parent: 'kiosk',
            url: '/kiosk-dashboard',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.kiosksDashboard.home.title'
            },
            params : {
                showCreation: {
                    value: false,
                    squash: true
                },
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                itemsPerPageChosen: null,
                predicates: {}
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard.html',
                    controller: 'KiosksDashboardsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates: $stateParams.predicates,
                        search: $stateParams.search,
                        showCreation: $stateParams.showCreation
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }) .state('kiosks-dashboard-new', {
            parent: 'kiosks-dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.kiosksDashboard.detail.title'
            },
            params : {
                registeredDashboard: {
                    value: [],
                    squash: true
                }
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-dialog.html',
                    controller: 'KiosksDashboardDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        registeredDashboard: $stateParams.registeredDashboard
                    }
                }],
                entity: ['$stateParams', 'KiosksDashboards', function ($stateParams, KiosksDashboards) {
                    return {};
                }]
            }

        })
        .state('kiosks-dashboard-kiosk', {
            parent: 'kiosks-dashboard',
            url: '/kiosk',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.kiosksDashboard.detail.title'
            },
            params : {
                selectedDashboards: {
                    value: [],
                    squash: true
                },
                kiosk: {
                    value: {},
                    squash: true
                }
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-kiosk.html',
                    controller: 'KiosksDashboardKioskController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        selectedDashboards: $stateParams.selectedDashboards,
                        kiosk: $stateParams.kiosk
                    }
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    $translatePartialLoader.addPart('kiosks');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }

        })
        .state('kiosks-dashboard-edit', {
            parent: 'kiosks-dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_TECH'],
                pageTitle: 'jotApp.kiosksDashboard.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-dialog.html',
                    controller: 'KiosksDashboardDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('kiosksDashboards');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'KiosksDashboards', function ($stateParams, KiosksDashboards) {
                    return KiosksDashboards.get({id: $stateParams.id});
                }]}

        })
        .state('kiosks-dashboard.delete', {
            parent: 'kiosks-dashboard',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/kiosks/kiosks-dashboard/kiosks-dashboard-delete-dialog.html',
                    controller: 'KiosksDashboardDeleteController',
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('kiosksDashboards');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: ['KiosksDashboards', function(KiosksDashboards) {
                            return KiosksDashboards.get({id: $stateParams.id});;
                        }]
                    }
                }).result.then(function() {
                    $state.go('kiosks-dashboard', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
